import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { formatDate } from '../../format';
import DateRangeStore from '../../stores/DateRangeStore';
import Actions from '../Actions/Actions';
import Button from '../Button';
import Modal from '../Modal';
import './RangePickerModal.css';

const block = b.lock('RangePickerModal');

class RangePickerModal extends Component {
    static propTypes = {
        dateRangeStore: DateRangeStore.PropType.isRequired,
        onApply: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        ...Modal.PropTypes,
    };

    getColumns = () => {
        const { dateRangeStore } = this.props;
        return [{
            title: 'START DATE',
            store: dateRangeStore.start,
        }, {
            title: 'END DATE',
            store: dateRangeStore.end,
        }];
    };

    render() {
        const { dateRangeStore, onApply, onCancel, ...props } = this.props;
        return <Modal
            className={block()}
            {...props}
        >
            <div className={block('Content')}>
                {this.getColumns().map(({ title, store }) => {
                    const { selectedDay } = store;
                    return <div
                        key={title}
                        className={block('Column')}
                    >
                        <div className={block('TitleWrapper')}>
                            <div className={block('Title')}>
                                {title}
                            </div>
                            <div className={block('Subtitle')}>
                                {store.date ? formatDate(store.date) : 'Select…'}
                            </div>
                        </div>
                        <div className={block('Month')}>
                            <Button
                                className={block('MonthNav')}
                                icon="keyboard_arrow_left"
                                onClick={store.showPrevMonth}
                            />
                            <div className={block('MonthTitle')}>
                                {store.monthTitle}
                            </div>
                            <Button
                                className={block('MonthNav')}
                                icon="keyboard_arrow_right"
                                onClick={store.showNextMonth}
                            />
                        </div>
                        <div className={block('Days')}>
                            {dateRangeStore.daysOfWeek.map((dayTitle, index) => <div
                                key={'wd' + index}
                                className={block('Day', { type: 'weekday' })}
                            >{dayTitle}</div>)}
                            {store.daysOfMonth.map((dayTitle, index) => (dayTitle ? <Button
                                key={dayTitle + ' ' + index}
                                className={block('Day', { type: 'day', active: dayTitle === selectedDay })}
                                onClick={() => store.setDay(dayTitle)}
                            >{dayTitle}</Button> : <div
                                key={dayTitle + ' ' + index}
                                className={block('Day', { type: 'padding' })}
                            />))}
                        </div>
                    </div>;
                })}
            </div>
            <Actions className={block('Actions')}>
                <Button
                    onClick={onCancel}
                    raised
                    secondaryWhite
                    fullWidth
                >CANCEL</Button>
                <Button
                    onClick={onApply}
                    raised
                    primary
                    fullWidth
                >APPLY</Button>
            </Actions>
        </Modal>;
    }
}

export default observer(RangePickerModal);
